import { SupportedTpaAppDefIds } from '@wix/a11y-adapters';
import { useCallback, useMemo } from 'react';
import { useGalleriesDataQuery } from '../../queries/use-galleries-data-query';
import { useWixVideoDataQuery } from '../../queries/use-wix-video-data-query';
import { TpaDataKey } from './types';
import { useSetGalleryItems } from './use-set-gallery-items';
import { useSetGalleryItemsV2 } from './use-set-gallery-items-v2';
export const useTpaEntityDataHandlers = () => {
  const {
    updateGalleryItems
  } = useSetGalleryItems();
  const {
    updateGalleryItems: updateGalleryItemsV2
  } = useSetGalleryItemsV2();
  const {
    refetch: fetchGalleriesData,
    data: galleriesDataMap
  } = useGalleriesDataQuery();
  const {
    refetch: fetchWixVideoData
  } = useWixVideoDataQuery();
  const tpaEntityDataHandlers = useMemo(() => ({
    [SupportedTpaAppDefIds.PRO_GALLERY]: {
      fetchData: async () => {
        const {
          data
        } = await fetchGalleriesData();
        return data;
      },
      key: TpaDataKey.ProGallery,
      setData: updateGalleryItems
    },
    [SupportedTpaAppDefIds.WIX_VIDEO]: {
      fetchData: async () => {
        const {
          data
        } = await fetchWixVideoData();
        return data;
      },
      key: TpaDataKey.WixVideo,
      setData: async () => {}
    }
  }), [fetchGalleriesData, fetchWixVideoData, updateGalleryItems]);
  const fetchTpaEntitiesData = async () => {
    const results = {};
    await Promise.all(Object.entries(tpaEntityDataHandlers).map(async _ref => {
      let [_, {
        fetchData,
        key
      }] = _ref;
      switch (key) {
        case TpaDataKey.ProGallery:
          results.proGallery = await fetchData();
          break;
        case TpaDataKey.WixVideo:
          results.wixVideo = await fetchData();
          break;
      }
    }));
    return results;
  };
  const setTpaEntityData = useCallback(async (appDefId, data, useAxeInfra) => {
    switch (appDefId) {
      case SupportedTpaAppDefIds.PRO_GALLERY:
        useAxeInfra ? await updateGalleryItemsV2(data) : await tpaEntityDataHandlers[appDefId].setData({
          galleriesDataMap,
          galleryItemsData: data
        });
        break;
      default:
        break;
    }
  }, [galleriesDataMap, tpaEntityDataHandlers, updateGalleryItemsV2]);
  return {
    fetchTpaEntitiesData,
    setTpaEntityData,
    tpaEntityDataHandlers
  };
};
//# sourceMappingURL=use-tpa-entity-data-handlers.js.map